import store from '../store';

export const authGuard = next => {
  if (store.state.auth.user) {
    if (store.state.auth.token.exp - new Date().getTime() < 0) {
      next('/login');
    } else {
      next();
    }
  } else {
    next('/login');
  }
};

export const adminGuard = next => {
  if (store.state?.auth?.user?.admin) {
    next();
  } else {
    next('/login');
  }
};
